import { IconButton, TextField } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { IInputProps } from './Input.types';
import { InputAdornmentStyled, InputStyled } from './Input.styled';

export const Input: FC<IInputProps> = ({
  onBlur,
  type,
  readOnly,
  errorMessage,
  autoComplete,
  addedInfo,
  error,
  fullWidth,
  maxLength,
  sx,
  rows,
  InputLabelProps,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [errorInput, setErrorInput] = useState(false);

  useEffect(() => {
    if (error) {
      setErrorInput(error);
    } else {
      setErrorInput(false);
    }
  }, [error]);

  const handleClickShowPassword = () => setShowPassword(show => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const isSafari =
    typeof navigator !== 'undefined' &&
    /Safari/.test(navigator.userAgent) &&
    !/Chrome|Chromium|Android/.test(navigator.userAgent);

  const inputType = type !== 'password' ? type : showPassword ? 'text' : 'password';
  return (
    <InputStyled>
      <TextField
        InputLabelProps={InputLabelProps}
        id={props.name}
        type={inputType}
        error={errorInput}
        size="small"
        autoComplete={autoComplete}
        onBlur={onBlur}
        minRows={rows}
        inputProps={{
          maxLength,
          autoComplete,
          readOnly
        }}
        sx={{
          ...(isSafari && {
            // Radical fix for Safari - completely hide legend
            '& .MuiOutlinedInput-notchedOutline legend': {
              display: 'none !important'
            },
            // Show legend only when label is active
            '& .MuiInputLabel-shrink + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline legend': {
              display: 'block !important',
              maxWidth: '100% !important',
              paddingLeft: '5px !important',
              paddingRight: '5px !important',
              animation: 'safari-legend-fix 0.0001s'
            },
            '& .MuiInputLabel-shrink + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline legend > span': {
              display: 'inline-block',
              padding: '0 4px',
              backgroundColor: 'white !important'
            },
            // Additional protection - hide legend through notchedOutline
            '& .MuiOutlinedInput-notchedOutline': {
              '& legend': {
                display: 'none !important'
              }
            },
            '& .MuiInputLabel-shrink + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
              '& legend': {
                display: 'block !important',
                maxWidth: '100% !important',
                paddingLeft: '5px !important',
                paddingRight: '5px !important'
              }
            },
            // Another approach - through fieldset
            '& .MuiOutlinedInput-notchedOutline fieldset legend': {
              display: 'none !important'
            },
            '& .MuiInputLabel-shrink + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline fieldset legend': {
              display: 'block !important',
              maxWidth: '100% !important',
              paddingLeft: '5px !important',
              paddingRight: '5px !important'
            },
            '@keyframes safari-legend-fix': {
              from: { opacity: 0.99 },
              to: { opacity: 1 }
            }
          })
        }}
        {...props}
      />
      {type === 'password' && (
        <InputAdornmentStyled position="end">
          <IconButton onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornmentStyled>
      )}
      {error && errorMessage && <p>{errorMessage}</p>}
      {addedInfo && <p>{addedInfo}</p>}
    </InputStyled>
  );
};
